module.exports = __webpack_public_path__ + "static/img/member12_bg.d9f3955.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member12_bg.png
// module id = zyzd
// module chunks = 1